import React from "react";
import tw from "twin.macro";

const Container = tw.div`bg-white p-6 rounded-lg shadow-md`;
const Heading = tw.h2`text-2xl font-bold text-gray-800 mb-6`;
const Table = tw.table`min-w-full table-auto`;
const TableHead = tw.thead``;
const TableRow = tw.tr`bg-gray-100`;
const TableHeader = tw.th`px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider`;
const TableBody = tw.tbody``;
const TableData = tw.td`px-6 py-4 whitespace-nowrap text-sm text-gray-700 border-b`;

const users = [
  { id: 1, name: "Meghana Bandi", email: "meghana@example.com", role: "Admin" },
  { id: 2, name: "Rashid Khan", email: "rashid@example.com", role: "Editor" },
  { id: 3, name: "Fatima Noor", email: "fatima@example.com", role: "Viewer" },
];

export default function Users() {
  return (
    <Container>
      <Heading>User Management</Heading>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeader>ID</TableHeader>
            <TableHeader>Name</TableHeader>
            <TableHeader>Email</TableHeader>
            <TableHeader>Role</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.id}>
              <TableData>{user.id}</TableData>
              <TableData>{user.name}</TableData>
              <TableData>{user.email}</TableData>
              <TableData>{user.role}</TableData>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Container>
  );
}
